module.exports = __webpack_public_path__ + "static/media/inmedtoryLogo.92997149.png";